import { Reveal } from "@/components/Reveal";

const partners = [
  { id: "nhs", logo: "/partners/nhs.svg", caption: "National Health Service", h: "h-12" },
  { id: "circle", logo: "/partners/circle.png", caption: "Circle Health Group", h: "h-10" },
  { id: "clove", logo: "/partners/clove.png", caption: "Clove Health", h: "h-8" },
  { id: "cambridge", logo: null, caption: null },
];

export const PartnerStrip = () => (
  <section className="bg-ivory border-b border-navy/10 py-16" data-testid="partner-strip">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-gold text-center mb-12">
          Organisations We Work With
        </p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12 items-center">
          {partners.map((p, i) => (
            <div
              key={p.id}
              className="flex flex-col items-center justify-center gap-4 opacity-80 hover:opacity-100 transition-opacity duration-300"
              data-testid={`partner-${p.id}`}
            >
              {p.logo ? (
                <img
                  src={p.logo}
                  alt={p.caption}
                  className={`${p.h} w-auto object-contain`}
                  data-testid={`partner-logo-${p.id}`}
                />
              ) : (
                <p className="font-serif text-xl font-semibold text-navy text-center leading-snug" data-testid="partner-wordmark-cambridge">
                  Cambridge Cardiovascular
                  <br />
                  Prevention Clinic
                </p>
              )}
              {p.caption && (
                <p className="font-mono text-[9px] tracking-[0.25em] uppercase text-navy/40 text-center">
                  {p.caption}
                </p>
              )}
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
